// import { isAuthticated } from "./actions"
import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  UPDATE_AUTH,
} from "./actionTypes"

const initialState = {
  userLogin: "",
  error: "",
  loading: false,
  authtication: false,
  // isAuth:false
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_AUTH:
      state = {
        authtication: action?.payload.isAuth,
      }
      break
    case LOGIN_USER:
      state = {
        userLogin: action?.payload?.user?.doc,
        loading: true,
        authtication: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        loading: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state, userLogin: "", authtication: false }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
